<div class="container-fluid py-3">
  <div class="row d-flex justify-content-center">
    <div class="col-md-12 d-flex flex-column align-items-center mb-5">
      <p
        class="fw-bolder fs-1 lh-lg m-0 text-black text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{ "A staff of creators" | translate }}
      </p>
      <p
        class="fs-5 text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="500"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{
          "A staff of creators working hard to create the most powerful applications and websites"
            | translate
        }}
      </p>
    </div>
    <!-- <div class="col-1 d-flex align-items-center justify-content-center">
      <div
        class="bg-secondary curser-pointer rounded-circle d-flex align-items-center justify-content-center"
        style="width: 40px; height: 40px"
      >
        <i class="fas fa-chevron-right fs-4 text-sec" (click)="prev()"></i>
      </div>
    </div> -->
    <div
      class="col-10"
      data-aos="fade-up"
      data-aos-duration="1000"
      [attr.data-aos-delay]="1000"
      data-aos-offset="50"
      data-aos-once="true"
    >
      <owl-carousel-o [options]="owlOptions" #owlCarousel>
        <ng-template carouselSlide *ngFor="let staff of staffs">
          <div class="slider-item">
            <div class="d-flex flex-column align-items-center w-100 gap-2">
              <img [src]="staff.photo" alt="" class="rounded-circle" />
              <p class="m-0 fw-bold fs-5">
                {{ lang == "en" ? staff.name_en : staff.name }}
              </p>
              <p class="m-0">
                {{ lang == "en" ? staff.title_en : staff.title }}
              </p>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
    <!-- <div class="col-1 d-flex align-items-center justify-content-center">
      <div
        class="bg-secondary curser-pointer rounded-circle d-flex align-items-center justify-content-center"
        style="width: 40px; height: 40px"
      >
        <i class="fas fa-chevron-left fs-4 text-sec" (click)="next()"></i>
      </div>
    </div> -->
  </div>
</div>
